import React, { memo } from 'react'

import { func, string } from 'prop-types'

import UpgradeCard from 'Pods/Shared/Waitlist/UpgradeCard/UpgradeCard'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import { buildSubscriptionHref, TODO_LEARN_MORE_HREF } from '../../constants'

// Store adapter for the shared UpgradeCard: reads the hydrated subscription values from the studio
// store and feeds them to the store-agnostic presentational card.
function UpgradeCardContainer({ onClose: handleClose, title = 'Upgrade to Keep Creating' }) {
  const subscriptionPrice = useThreeDStudioStore(state => state.subscription.subscriptionPrice)
  const subscriptionOriginalPrice = useThreeDStudioStore(
    state => state.subscription.subscriptionOriginalPrice
  )
  const subscriptionMonthlyModels = useThreeDStudioStore(
    state => state.subscription.subscriptionMonthlyModels
  )
  const subscriptionPaymentFormUrl = useThreeDStudioStore(
    state => state.subscription.subscriptionPaymentFormUrl
  )

  return (
    <UpgradeCard
      title={title}
      price={subscriptionPrice}
      originalPrice={subscriptionOriginalPrice}
      monthlyModels={subscriptionMonthlyModels}
      subscriptionHref={buildSubscriptionHref(subscriptionPaymentFormUrl)}
      learnMoreHref={TODO_LEARN_MORE_HREF}
      onClose={handleClose}
    />
  )
}

UpgradeCardContainer.propTypes = {
  onClose: func.isRequired,
  title: string,
}

export default memo(UpgradeCardContainer)
